// External Imports
import { useContext } from 'react';

// Internal Imports
import { ContentEmbedContext } from '../context/contentEmbed.js';

// Local Functions
const useContentEmbed = () => useContext(ContentEmbedContext);

// Module Exports
export { useContentEmbed };
